import { render, staticRenderFns } from "./AiDocspiece.vue?vue&type=template&id=82a71bd6&scoped=true"
import script from "./AiDocspiece.vue?vue&type=script&lang=js"
export * from "./AiDocspiece.vue?vue&type=script&lang=js"
import style0 from "./AiDocspiece.vue?vue&type=style&index=0&id=82a71bd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a71bd6",
  null
  
)

export default component.exports